import Default from './Default.vue'

export default Default



// WEBPACK FOOTER //
// ./src/components/echarts/line/default/index.js